module.exports = __webpack_public_path__ + "static/img/home.e416b22.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/skinAnalysis/home.gif?v=1
// module id = HQGR
// module chunks = 1